import dateRangePickerDirective from 'directives/dateRangePicker';
import fullcalendarDirective from 'directives/fullcalendar';
import imgUploadDirective from 'directives/imgUpload';
import loadingDirective from 'directives/loading';
import sidebarDirective from 'directives/sidebar';
import sidebarCtrl from 'directives/sidebar/controller';

function init(app) {
  if (!app) throw new Error('app is required');

  app.directive('dateRangePicker', dateRangePickerDirective);
  app.directive('fullcalendar', fullcalendarDirective);
  app.directive('imgUpload', imgUploadDirective);
  app.directive('loading', loadingDirective);
  app.directive('sidebar', sidebarDirective);
  app.controller('sidebarCtrl', sidebarCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/directives/index.js